"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefillDetailPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const refill_detail_1 = require("../../sections/refill-detail");
const react_router_dom_1 = require("react-router-dom");
const RefillDetailPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    return (0, jsx_runtime_1.jsx)(refill_detail_1.RefillDetailComponent, { id: id ?? '' });
};
exports.RefillDetailPage = RefillDetailPage;
